import React, { useState, createContext } from "react";
import Cookies from "js-cookie";
export const UserContext = createContext();
export const UserProvider = (props) => {
  const [user, setUser] = useState({
    name: "",
    email: "",
    token: "",
  });
  const [loginStatus, setLoginStatus] = useState(false);

  if (loginStatus === false) {
    const usernameCookies = Cookies.get("username");
    const emailCookies = Cookies.get("email");
    const tokenCookies = Cookies.get("token");
    if (usernameCookies) {
      setLoginStatus(true);
      setUser({
        name: usernameCookies,
        email: emailCookies,
        token: tokenCookies,
      });
    }
  }
  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        loginStatus,
        setLoginStatus,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};
